import { render } from "./ReisethemenMenu.vue?vue&type=template&id=0c05ace3"
import script from "./ReisethemenMenu.vue?vue&type=script&lang=js"
export * from "./ReisethemenMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__